import { JwtPayload, jwtDecode } from "jwt-decode";

const getUserPermissions = () => {
  const token = localStorage.getItem("access_token");
  if (!token) {
    return null;
  }
  try {
  const decoded: {
    access?: any;
    planHierarchy: string;
    MaxEmployee: string;
    MaxWareHouse: string;
    StartView: string;
    freeTrial: string;
    isAdmin: string;
    JwtPayload: JwtPayload;
    MaxSalebox: string;
  } = jwtDecode(token);
  const account_info: any = JSON.parse(localStorage.getItem("account_info") || "{}");
    const permissions = {
      accessKeyModules: decoded?.access
        ? JSON.parse(decoded.access).map((item: any) => {
            // Formato nuevo: array de UUIDs strings. Retrocompat: objetos {UUIDModule, Hierarchy}.
            if (typeof item === 'string') return { id: item, hierarchy: 0 };
            return { id: item.UUIDModule, hierarchy: item.Hierarchy };
          })
        : [],
      plan: {
        id: account_info?.plan?.id,
        name: account_info?.plan?.name,
        hierarchy: Number(decoded.planHierarchy) || 0,
        isTrial: decoded.freeTrial ? JSON.parse(decoded.freeTrial.toLowerCase()) : false,
      },
      account: {
        isAdmin: decoded.isAdmin ? JSON.parse(decoded.isAdmin.toLowerCase()) : false,
      },
      employeesLimitCount: Number(decoded?.MaxEmployee),
      warehousesLimitCount: Number(decoded?.MaxWareHouse),
      boxesLimitCount: Number(decoded?.MaxSalebox),
      startView: decoded?.StartView,
    };
    return permissions;
  } catch (error) {
    console.error("Error getting user permissions", error);
    localStorage.clear();
    // replace fuerza carga real aunque ya estemos en "/" (href a la misma URL
    // no recarga en Chrome → app montada sin sesión → pantalla en blanco).
    window.location.replace("/");
    return null;
  }
};

export default getUserPermissions;
